<template>
    <header
        :class="['header', {'is-open': isOpen}]"
        v-if="visibility !== 'hidden'"
    >
        <router-link class="header__index" v-if="visibility === 'with-index'" to="/">
            <icon-header-logo/>
        </router-link>
        <div class="header__in-menu">
            <button @click="toggleHeader" class="header-btn">{{isOpen ? 'Close' : 'Menu'}}</button>
            <nav 
                v-show="isOpen"
                class="header-nav"
            >
                <div class="header-nav-list">
                    <router-link :to="{name: 'directors'}" class="header-nav-list-item"><span @click="toggleHeader">Directors</span></router-link>
                    <router-link :to="{name: 'contact'}" class="header-nav-list-item"><span @click="toggleHeader">Contact</span></router-link>
                    <div class="separator"></div>
                    <a href="https://ubiquity.tv/n/print" class="header-nav-list-item">Print</a>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>

// Components
import IconHeaderLogo from '../icons/icon-header-logo'

export default {
    components: {
        "icon-header-logo": IconHeaderLogo,
    },
    props: {
        visibility: {
            type: String,
        }
    },
    data: function(){
        return {
            isOpen: false
        }
    },
    methods: {
        toggleHeader: function(){
            let nextState = !this.isOpen
            this.isOpen = nextState

            document.body.classList[nextState ? "add" : "remove"]("modal-is-open")
        }
    },
    name: "LayoutHeaderMobile"
}
</script>

<style lang="scss">
    .header{
        @include fixed-top();
        z-index: 30;

        .icon__header-logo{
            width: 157px;
            position: absolute;
            left: 33px;
            top: 33px;

            @include very-small{
                width: 120px;
                left: 22px; // related to close
                top: 22px; // related to close
            }
        }

        &.is-open{
            height: 100%;
            pointer-events: all;
        }

        &-btn{
            position: absolute;
            right: 33px;
            top: 33px;
            text-transform: uppercase;
            letter-spacing: 3px;
            z-index: 100;
            padding-left: 25px;
            padding-bottom: 25px;

            @include very-small{
                font-size: ptToPx(11);
                right: 22px;  // related to header logo
                top: 22px; // related to header logo
                
                padding-left: 35px;
                padding-bottom: 35px;
            }
        }

        &__in-menu{
            height: 100%;
            background-color: $black;
            position: relative;
            z-index: 1;
        }

        &-nav{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            &-list{

                .separator{
                    width: 70px;
                    height: 1px;
                    background-color: $white;
                    margin: 25px auto;

                    @include very-small{
                        margin: 18px auto;
                    }
                }

                &-item{
                    font-size: ptToPx(32);
                    line-height: ptToPx(50);
                    font-weight: 700;
                    text-transform: uppercase;
                    text-align: center;
                    font-family: $font-title;

                    @include very-small{
                        font-size: ptToPx(22);
                        line-height: ptToPx(35);
                    }

                    span{
                        display: block;
                    }
                }
                
                & > *{
                    display: block;
                }
            }
        }
    }
</style>